export function PreventInstallPrompt() {
  window.addEventListener("beforeinstallprompt", (e: Event) => {
    e.preventDefault();
    (window as any).deferredPrompt = e;

    return false;
  });
}

export function OpenInstallLink() {
  const userAgent = navigator.userAgent || navigator.vendor;
  let link = "https://play.google.com/store/apps/details?id=com.poppedidos.garcom";

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    link = "https://apps.apple.com/app/example-app/123456789";
  }

  window.open(link, "_blank");
}

export async function InstallPrompt() {
  const { deferredPrompt } = window as any;

  if (deferredPrompt) {
    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;
    if (outcome !== "accepted") OpenInstallLink();
  } else {
    OpenInstallLink();
  }
}
